/* tslint:disable */
/* eslint-disable */
/**
 * Incendium AI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { ApiAuthProjectFromJSON, ApiAuthProjectToJSON, } from './ApiAuthProject';
export function ApiListUserProjectsResponseFromJSON(json) {
    return ApiListUserProjectsResponseFromJSONTyped(json, false);
}
export function ApiListUserProjectsResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'projects': !exists(json, 'projects') ? undefined : (json['projects'].map(ApiAuthProjectFromJSON)),
    };
}
export function ApiListUserProjectsResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'projects': value.projects === undefined ? undefined : (value.projects.map(ApiAuthProjectToJSON)),
    };
}
